define('Components/LandingWidget/js/views/SummerCreationsWidgetInstanceView',['jquery', 'app', 'Components/LandingWidget/js/views/LandingWidgetInstanceView'],
    function ($, app, LandingWidgetInstanceView) {
        return LandingWidgetInstanceView.extend({
            
            afterRender: function () {
                var view = this;
                //
                view.listenTo(app, 'change:scrollTop', view.onScroll);
                setTimeout(function () {
                    view.onScroll();
                }, 500);

            },
            
            onScroll:function(){
                var view = this;
                view.$('.animate-on-scroll').each(function () {
                    if ($(window).scrollTop() > $(this).offset().top - $(window).height() * 0.75) {
                        $(this).addClass('active');
                    }
                });
            },
            
        })
});
